import { FC, useState } from "react";
import SchoolTypeSelect from "../../common/SchoolTypeSelect";
import Button from "../../Button";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import QueryString from "qs";
import { IGetPublishersParams } from "../../../models/publishers.model";
import config from "../../../lib/config";

const PublisherSearchForm: FC = () => {
  const { t } = useTranslation();
  const history = useHistory();

  const [schoolGbn, setSchoolGbn] = useState('');
  const [schoolName, setSchoolName] = useState('');

  const onSearch = () => {
    const params: IGetPublishersParams = {
      pageNo: 1,
      perPage: config.pageSize,
    };
    if (schoolGbn) {
      params.schoolGbn = schoolGbn;
    }
    if (schoolName) {
      params.schoolName = schoolName;
    }

    history.push(`/system/publisher?${QueryString.stringify(params)}`);
  };

  return (
    <div className="flex flex-justify-center">
      <div className="card">
        <div className="card-body">
          <div className="row">
            <div className="w-150p mr-1">
              <SchoolTypeSelect
                schoolGbn={schoolGbn}
                setSchoolGbn={setSchoolGbn}
              />
            </div>
            <input
              type="text"
              className="form-control w-240p"
              placeholder={t('system.school.placeholder')}
              value={schoolName}
              onChange={(e => setSchoolName(e.target.value))}
              onKeyPress={e => { if (e.key === 'Enter') onSearch() }}
            />
            <Button
              className='btn btn-secondary ml-3 btn-w100p'
              onClick={onSearch}
              text={t('common.button.search')}
            />
          </div>              
        </div>
      </div>
    </div>
  );
};

export default PublisherSearchForm;